import store from "../store/index";
import { StorageService } from "@/services/StorageService";

export const authorizeToken = (to, from, next) => {
    // Check if token exists in store state or localStorage
    const token = store.state.auth.token || StorageService.getAuthToken();
    
    if (to.matched.some(record => record.meta.requireAuth) && !token) {  
        next("/login")
    } else { 
        next()
    }
}